import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

const PageNotFoundFile = () => {
  const history = useHistory();

  return (
    <Box
      sx={{
        minHeight: {
          xs: '75vh',
          sm: '100%',
        },
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: 2,
        fontFamily: 'Poppins',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: '100px', sm: '140px' },
          fontWeight: 700,
          color: '#000000',
          fontFamily: 'Poppins',
        }}
      >
        404
      </Typography>

      <Typography variant="h4" sx={{ color: '#000', fontFamily: 'Poppins' }}>
        Page Not Found
      </Typography>

      <Button
        variant="text"
        onClick={() => history.push('/dashboard')}
        style={{
          padding: '10px 39px',
          height: '41px',
          fontSize: '20px',
          color: '#4CA4D6',
          textTransform: 'none',
          fontWeight: 500,
          fontFamily: 'Poppins',
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none',
        }}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default PageNotFoundFile;
